export enum PickupsPath {
  pickupNumber = "pickupNumber"
}

export interface PathParams {
  [PickupsPath.pickupNumber]: string;
}
